import React, { type ReactNode } from 'react';
import Flag from '@atlaskit/flag';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';

type RefreshBannerProps = Readonly<{
	actionLabel: ReactNode;
	reloadEP: () => void;
	title: ReactNode;
}>;

const RefreshBanner = ({ reloadEP, title, actionLabel }: RefreshBannerProps): React.JSX.Element => (
	<Flag
		icon={
			<StatusSuccessIcon spacing="spacious" color={token('color.icon.information')} label="Info" />
		}
		id="refreshBanner"
		title={title}
		actions={[{ content: actionLabel, onClick: reloadEP }]}
	/>
);

export default RefreshBanner;
